import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { AUTH } from "@/constants/testIds";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center bg-[#050914] px-5">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6">
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>
        <div className="rounded-2xl glass p-8">
          <div className="flex items-center gap-3 mb-6">
            <Logo size={48} />
            <div>
              <div className="font-display text-xl font-bold text-white">Admin Access</div>
              <div className="text-xs text-white/50">Authority Detailing Co.</div>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <Input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Admin email" className="bg-white/5 border-white/10 text-white h-12"
              data-testid={AUTH.loginEmail}
            />
            <Input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Password" className="bg-white/5 border-white/10 text-white h-12"
              data-testid={AUTH.loginPassword}
            />
            {err && <div className="text-sm text-red-400">{err}</div>}
            <button
              type="submit" disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white font-semibold py-3.5 rounded-md transition-all"
              data-testid={AUTH.loginSubmit}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
